import { useCallback, useContext, useEffect, useState } from 'react'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import { ToastNotificationContext } from '../../../global/context/toast-context/ToastNotificationContext'
import { fetchData } from '../../../global/utils/fetch'
import {
  getDocuments,
  deleteDocument,
} from '../../api'
import DocumentTable, { DocumentListItem } from '../document-table/DocumentTable'
import UploadModal from '../upload-modal/UploadModal'
import TableTopper from '../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../global/components/table/helpers/table-title/TableTitle'

function TechnicianAssistantContent() {
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)

  // Documents state
  const [documents, setDocuments] = useState<DocumentListItem[]>([])
  const [isDocumentsLoading, setIsDocumentsLoading] = useState(true)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)

  const loadDocuments = useCallback(async () => {
    setIsDocumentsLoading(true)
    try {
      const data = await fetchData<DocumentListItem[]>(getDocuments())
      setDocuments(data)
    } catch (error: any) {
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: error.message || 'Failed to load documents.',
        severity: 'error',
      })
    } finally {
      setIsDocumentsLoading(false)
    }
  }, [])

  useEffect(() => {
    loadDocuments()
  }, [loadDocuments])

  async function handleDeleteDocument(documentObjectId: string) {
    if (!window.confirm('Are you sure you want to delete this document?')) return

    try {
      await fetchData(deleteDocument(documentObjectId))
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Document deleted.',
        severity: 'success',
      })
      loadDocuments()
    } catch (error: any) {
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: error.message || 'Failed to delete document.',
        severity: 'error',
      })
    }
  }

  return (
    <>
      <TableTopper>
        <TableTitle>
          <>Documents</>
        </TableTitle>
        <PrimaryButton
          buttonName='Upload Document'
          onClick={() => setIsUploadModalOpen(true)}
        />
      </TableTopper>
      <DocumentTable
        documents={documents}
        isLoading={isDocumentsLoading}
        onDelete={handleDeleteDocument}
      />
      <UploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUploadComplete={loadDocuments}
      />
    </>
  )
}

export default TechnicianAssistantContent
